const account_center = {
    not_enabled: '계정 센터가 활성화되어 있지 않습니다.',
    filed_not_editable: '필드를 편집할 수 없습니다.',
};
export default Object.freeze(account_center);
